<template>
  <div class="story">
    <!-- Hero -->
    <section class="hero">
      <div class="hero-content">
        <h1>一切都关乎于爱</h1>
        <p class="hero-subtitle">宠物星系与地球所发生的这一切都关乎于爱</p>
      </div>
    </section>

    <!-- 宠物星系介绍 -->
    <section class="intro-section">
      <div class="container">
        <div class="intro-content">
          <div class="intro-text">
            <h2>陪伴我们的萌宠们来自哪里？</h2>
            <p class="intro-question">ta们的家园是什么样子的？ta为什么要来到地球呢？ta们和我们是什么关系？</p>
            <p class="intro-desc">在浩瀚无涯的宇宙中，有很多奇妙且不为人知的星系，其中在人类可观测宇宙之外的遥远地方有一个神秘而美丽的星系，叫做<span class="highlight">"宠物星系"</span>。</p>
          </div>
          <div class="intro-image">
            <img src="/story.jpg" alt="宠物星系" class="story-img">
          </div>
        </div>
      </div>
    </section>

    <!-- 宠物星系的星球 -->
    <section class="planets-section">
      <div class="container">
        <div class="planets-content">
          <div class="planets-image">
            <img src="/story2.jpg" alt="宠物星球" class="story-img">
          </div>
          <div class="planets-text">
            <p>宠物星系里有众多的小行星，有<span class="planet-name">喵星球</span>、<span class="planet-name">汪星球</span>、<span class="planet-name">兔星球</span>、<span class="planet-name">吱星球</span>、<span class="planet-name">异宠星球</span>等，宠物星系的居民们都在各自的星球上快乐的生活着。</p>
            <p>宠物星系是地球上所有宠物的家园，宠星人在各自的星球出生，成长，学习，工作与生活。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 宠物星系的生活 -->
    <section class="life-section">
      <div class="container">
        <div class="life-content">
          <div class="life-text">
            <p>这里的自然环境十分优美，山清水秀，四季分明且没有灾祸；社会极度发达，所有的宠物都做着自己喜欢的工作，大家按需分配，社会和谐安定；宠星人的家庭美满和睦，大家友爱团结，没有痛苦与疾病，充满爱与欢乐。</p>
          </div>
          <div class="life-image">
            <img src="/story3.jpg" alt="宠物星系生活" class="story-img">
          </div>
        </div>
      </div>
    </section>

    <!-- 爱的能力 -->
    <section class="love-ability-section">
      <div class="container">
        <div class="love-ability-content">
          <div class="love-ability-image">
            <img src="/story4.jpg" alt="爱的能力" class="story-img">
          </div>
          <div class="love-ability-text">
            <p>宠星人在各自星球成长的过程中要学习各种各样的能力，比如工作的能力、表达的能力、算数的能力、爱的能力等等，其中<span class="highlight">感恩与爱的能力</span>在宠物星系是最核心最重要的能力，也是在这里生活最宝贵的财富。</p>
            <p>和人类幼年一样，宠星人的学习过程也是"艰辛"的，他们要通过各种科目的学习与考核，成年的时候才能成为一个合格的宠星人进入社会快乐的生活。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 地球课堂 -->
    <section class="earth-class-section">
      <div class="container">
        <div class="earth-class-content">
          <div class="earth-class-text">
            <h3>《爱》是宠星人学习生涯的最后也是最特殊的一课</h3>
            <p>因为宠星已经拥有高度的文明所以大部分的知识都可以在本星球完成学习，但爱并不是宠星居民天生的能力。因此他们会去到一个有爱的星球完成这重要的一课，这个星球就是我们生活的地方——<span class="highlight">地球</span>。</p>
            <p>这门课的课堂在地球，老师和同学都是人类，为什么这么说呢？因为虽然人类天生就拥有爱的能力，但每个人爱的能力的大小，展现爱的方式，以及唤醒自己爱的能力的时间是不同的，因此在教会宠星人爱的同时<span class="highlight">人类的爱也得到了催化与升华</span>。</p>
          </div>
          <div class="earth-class-image">
            <img src="/story5.jpg" alt="地球课堂" class="story-img">
          </div>
        </div>
      </div>
    </section>

    <!-- 地球旅程 -->
    <section class="journey-section">
      <div class="container">
        <div class="journey-content">
          <div class="journey-image">
            <img src="/story6.jpg" alt="地球旅程" class="story-img">
          </div>
          <div class="journey-text">
            <p>宠星人在地球会面临各种在宠星无法想象的经历，有痛苦与绝望、有辛酸与无奈、有离别与重逢当然还有欢乐与感恩，爱与被爱~</p>
            <p>他们会在规定时间来到地球，从零开始学习，学习完成后回到宠星进行考核，考核的标准是在地球有没有真正的学到感恩与爱，以及有没有得到更多的爱。考核合格就会结束学习阶段正式宣布成年成为优秀的宠星人，如果没有通过还会回到地球继续学习，直到掌握这个能力。</p>
            <p class="journey-highlight">因此，可以说宠星人在地球的一生就是寻找并学习爱与被爱的旅程。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 永恒的纽带 -->
    <section class="bond-section">
      <div class="container">
        <div class="bond-content">
          <div class="bond-text">
            <p>随着人类社会的发展，物质及思想的进步，人们变得越来越有爱，这使得来到地球学习的宠星人也越来越顺利，进而极大的促进了各宠物星球的发展。而对于在银河系中孤独的地球来说这是非常有意义的联系，人类由于宠星人的出现与陪伴也加深并提早懂得了爱的意义。</p>
            <p>宠星人在地球的一生会和自己的主人建立深厚的感情，在他们离开地球回到宠星后会记得与地球主人在一起的一点一滴，<span class="highlight">用特殊的方式建立与主人的联系</span>，会把地球的摆件和主人的照片放在床前，每日思念，建立起以爱为纽带的关系并永恒不灭。</p>
          </div>
          <div class="bond-image">
            <img src="/story7.jpg" alt="永恒的纽带" class="story-img">
          </div>
        </div>
      </div>
    </section>

    <!-- 结语 -->
    <section class="ending-section">
      <div class="container">
        <div class="ending-content">
          <p class="ending-text">爱的力量是强大的，是爱让我们相遇，是爱让我们更加懂得感恩与珍惜，宠物星系与地球所发生的这一切都关乎于爱！</p>
          <div class="brand-info">
            <h3>关于宠物星系</h3>
            <p>宠物星系是一个以爱为核心的宠物纪念品牌</p>
            <p>我们会始终将<strong>爱与感恩</strong>、<strong>细节与品质</strong>作为品牌的核心价值注入每一项产品与服务</p>
            <p class="brand-slogan">— 一切都关乎于爱 —</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Story'
}
</script>

<style scoped>
.story {
  padding-top: 70px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero */
.hero {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  padding: 120px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 70%, rgba(123, 104, 238, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 30%, rgba(230, 168, 215, 0.1) 0%, transparent 40%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
  border-radius: 50%;
  box-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero h1 {
  font-size: 3.5rem;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 700;
  text-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero-subtitle {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 2px;
}

/* 通用图片样式 */
.story-img {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(48, 43, 99, 0.15);
}

/* 介绍部分 */
.intro-section {
  padding: 100px 0;
  background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);
}

.intro-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.intro-text h2 {
  font-size: 2rem;
  color: #302b63;
  margin-bottom: 20px;
  font-weight: 600;
}

.intro-question {
  font-size: 1.1rem;
  color: #7b68ee;
  line-height: 1.8;
  margin-bottom: 25px;
  font-weight: 500;
}

.intro-desc {
  color: #555;
  line-height: 1.9;
  font-size: 1.05rem;
}

.highlight {
  color: #7b68ee;
  font-weight: 600;
}

.intro-image {
  display: flex;
  justify-content: center;
}

/* 星球部分 */
.planets-section {
  padding: 80px 0;
  background: #fff;
}

.planets-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.planets-image {
  display: flex;
  justify-content: center;
}

.planets-text p {
  color: #555;
  line-height: 1.9;
  margin-bottom: 20px;
  font-size: 1.05rem;
}

.planet-name {
  color: #7b68ee;
  font-weight: 600;
}

/* 生活部分 */
.life-section {
  padding: 80px 0;
  background: linear-gradient(180deg, #f0edff 0%, #f8f7ff 100%);
}

.life-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.life-text p {
  color: #555;
  line-height: 1.9;
  font-size: 1.05rem;
}

.life-image {
  display: flex;
  justify-content: center;
}

/* 爱的能力部分 */
.love-ability-section {
  padding: 80px 0;
  background: #fff;
}

.love-ability-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.love-ability-image {
  display: flex;
  justify-content: center;
}

.love-ability-text p {
  color: #555;
  line-height: 1.9;
  margin-bottom: 20px;
  font-size: 1.05rem;
}

/* 地球课堂部分 */
.earth-class-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  position: relative;
  overflow: hidden;
}

.earth-class-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(123, 104, 238, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(230, 168, 215, 0.1) 0%, transparent 40%);
  pointer-events: none;
}

.earth-class-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.earth-class-text h3 {
  font-size: 1.5rem;
  color: #e6a8d7;
  margin-bottom: 25px;
  font-weight: 600;
}

.earth-class-text p {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.9;
  margin-bottom: 20px;
  font-size: 1.05rem;
}

.earth-class-image {
  display: flex;
  justify-content: center;
}

/* 旅程部分 */
.journey-section {
  padding: 80px 0;
  background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);
}

.journey-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.journey-image {
  display: flex;
  justify-content: center;
}

.journey-text p {
  color: #555;
  line-height: 1.9;
  margin-bottom: 20px;
  font-size: 1.05rem;
}

.journey-highlight {
  color: #7b68ee;
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 25px;
}

/* 纽带部分 */
.bond-section {
  padding: 80px 0;
  background: #f0edff;
}

.bond-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.bond-text p {
  color: #555;
  line-height: 1.9;
  margin-bottom: 20px;
  font-size: 1.05rem;
}

.bond-image {
  display: flex;
  justify-content: center;
}

/* 结语部分 */
.ending-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 100%);
  position: relative;
  overflow: hidden;
}

.ending-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 50% 50%, rgba(123, 104, 238, 0.1) 0%, transparent 60%);
  pointer-events: none;
}

.ending-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.ending-text {
  font-size: 1.3rem;
  color: #e6a8d7;
  line-height: 1.8;
  margin-bottom: 60px;
  font-weight: 500;
}

.brand-info h3 {
  font-size: 1.8rem;
  color: #fff;
  margin-bottom: 20px;
}

.brand-info p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 10px;
}

.brand-info strong {
  color: #e6a8d7;
}

.brand-slogan {
  margin-top: 30px;
  font-size: 1.2rem;
  color: #9d7bff;
  letter-spacing: 3px;
}

/* 响应式 */
@media (max-width: 968px) {
  .intro-content,
  .planets-content,
  .life-content,
  .love-ability-content,
  .earth-class-content,
  .journey-content,
  .bond-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .intro-image,
  .planets-image,
  .life-image,
  .love-ability-image,
  .earth-class-image,
  .journey-image,
  .bond-image {
    order: -1;
  }

  .hero h1 {
    font-size: 2.5rem;
  }

  .intro-text h2 {
    font-size: 1.6rem;
  }
}

@media (max-width: 600px) {
  .hero {
    padding: 80px 20px;
  }

  .hero h1 {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .intro-section,
  .planets-section,
  .life-section,
  .love-ability-section,
  .earth-class-section,
  .journey-section,
  .bond-section,
  .ending-section {
    padding: 60px 0;
  }

  .ending-text {
    font-size: 1.1rem;
  }

  .brand-info h3 {
    font-size: 1.5rem;
  }
}
</style>
